/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { cssMap, jsx } from '@atlaskit/css';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './ManageMemoryEditsSubscreen.messages';

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		border: `${token('border.width')} solid ${token('color.border')}`,
		borderRadius: token('radius.xlarge'),
		overflow: 'hidden',
	},
	centeredContent: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		flex: '1 1 0%',
		minHeight: '200px',
		paddingBlock: token('space.400'),
		paddingInline: token('space.300'),
		textAlign: 'center',
	},
	errorStateContent: {
		maxWidth: '430px',
	},
});

type ErrorStateProps = {
	onRetry?: () => Promise<void>;
};

export const ErrorState = ({ onRetry }: ErrorStateProps): JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={styles.container}>
			<Box xcss={styles.centeredContent}>
				<Stack alignInline="center" space="space.250" xcss={styles.errorStateContent}>
					<Text as="p" color="color.text.subtle" size="medium">
						{formatMessage(messages.errorMessage)}
					</Text>
					{onRetry && (
						<Button appearance="default" onClick={onRetry}>
							{formatMessage(messages.retryButton)}
						</Button>
					)}
				</Stack>
			</Box>
		</Stack>
	);
};
